import { render, staticRenderFns } from "./PhonePreviewSportBlock.vue?vue&type=template&id=b459f806&scoped=true&"
import script from "./PhonePreviewSportBlock.vue?vue&type=script&lang=js&"
export * from "./PhonePreviewSportBlock.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreviewSportBlock.vue?vue&type=style&index=0&id=b459f806&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b459f806",
  null
  
)

export default component.exports